<template>
  <tr>
    <td style="text-transform: capitalize;">
      <b>{{ item.type_display }}</b>
      <div
        v-if="item.custom_report"
      >
        <small>
          {{ getDomainInfo && getDomainInfo.reports.custom.find(r => r.id === item.custom_report).name }}
        </small>
      </div>
    </td>
    <td
      style="padding: 5px;"
    >
      <span
        v-if="item.parsed_filters && Object.keys(item.parsed_filters).length > 0"
        v-html="filterString(item.parsed_filters)"
      />
      <v-chip
        v-else
        small
        label
        text-color="black"
      >
        No Filter Conditions
      </v-chip>
    </td>
    <td>
      <span>{{ convertToLocal(item.created_at) }}<br /><small>{{item.created_by_name || 'Importer'}}</small></span>
    </td>
    <td>
      <ReportProgressBar
        :item="item"
        @download="downloadReport(report.id, item.file_name)"
      />
    </td>
    <td style="text-transform: capitalize;padding:0;">
      <v-tooltip
        v-if="item.status === 'finished' && !item.custom_report"
        left
      >
        <v-btn
          fab
          small
          flat
          :to="{name: 'CreateReport', query: {copy: report.id}}"
          slot="activator"
        >
          <v-icon
          >
            refresh
          </v-icon>
        </v-btn>
        <span>Re-Run Report</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
import api from '@/api'
import ReportProgressBar from '@/components/admin/reports/ReportProgressBar'

export default {
  name: 'ReportRow',
  props: [ 'report' ],
  components: {
    ReportProgressBar
  },
  data () {
    return {
      interval: null,
      dead: false,
      item: JSON.parse(JSON.stringify(this.report))
    }
  },
  created () {
    this.restartInterval()
  },
  methods: {
    randInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    restartInterval () {
      if (!this.dead) {
        clearInterval(this.interval)
        if (this.item.status !== 'finished' && this.item.status !== 'failed') {
          this.interval = setInterval(() => {
            this.update()
          }, this.randInt(4500, 7500))
        }
      }
    },
    update() {
      api.reports.reports.get(this.item.id)
        .then(data => {
          this.restartInterval()
          this.item = data
        })
    },
    downloadReport (id, name) {
      this.$emit('downloading', true)
      api.reports.reports.downloadReport(id)
      .then(response => {
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = name
        link.click()
        this.$emit('downloading', false)
      })
    },
    filterString (filter) {
      var string = ""
      try {
        if (filter.template) {
          string = `Selecting Template <span class="attention">${filter.template.name}</span>`
        }
        if (filter.casetype) {
          string += `in <span class="attention">${filter.casetype.name}</span>`
        }
        if (this.report.type == 'contact file report') {
          string = `Selected`
          if (!filter.is_read) {
            string += ` <span class='attention'>Unread</span> `
          }
          string += `Contact Files`
        }
        if (filter.contact_upload) {
          string += ` <span class='attention'>Uploaded by Contact</span>`
        }
        if (filter.tags) {
          string += ` with Tags `
          filter.tags.forEach((tag, index) => {
            string += "<span class='attention'>"
            string += tag
            string += "</span>"
          })
        }
        if (filter.statuses) {
          string += ` with Status `
          filter.statuses.forEach((status, index) => {
            string += "<span class='attention'>"
            string += status
            string += "</span>"
          })
        }
        if (this.report.set_read) {
          string += `<br /><i>Files Read by Report</i>`
        }
        return string
      } catch (err) {
        return "Invalid Filter Conditions"
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.dead = true
  }
}
</script>
